import React from "react";
import { Box } from "@mui/material";
import PropTypes from "prop-types";
import usePlanner from "features/planner/state/usePlanner";
import useDeviceType from "hooks/useDeviceType";
import { createSimpleHandler } from "features/planner/utils/inputValidation";
import colors from "app/theme/base/colors";
import { alpha } from "@mui/material/styles";

export default function DayLabelInput({ dayKey, defaultLabel }) {
  const { programState, setDayLabel } = usePlanner();
  const { isLaptop } = useDeviceType();

  const value = programState.days[dayKey].label;

  return (
    <Box
      sx={{
        width: "100%",
        minWidth: 0,
        height: isLaptop ? "80%" : "100%", // ✔ altura controlada en laptop
        display: "flex",
        alignItems: "center",
        backgroundColor: "grey.100",
        borderRadius: "6px",
        border: "1px solid",
        borderColor: "grey.300",
        px: 0.7,
        overflow: "hidden",

        "&:hover": {
          backgroundColor: (theme) => alpha(theme.palette.primary.main, 0.06),
          borderColor: "primary.main",
        },
      }}
    >
      <input
        type="text"
        value={value}
        onChange={createSimpleHandler("dayLabel", (v) => setDayLabel(dayKey, v))}
        placeholder={defaultLabel}
        maxLength={30}
        style={{
          flex: 1,
          minWidth: 0,
          border: "none",
          outline: "none",
          background: "transparent",
          padding: 0,
          margin: 0,

          fontSize: isLaptop ? "0.72rem" : "0.85rem",
          lineHeight: 1.25,

          fontWeight: value ? 500 : 400,
          color: value ? colors.text.primary : colors.grey[500],

          letterSpacing: "0px", // 🔴 clave: quitar tracking
          fontFamily: "Inter, system-ui, -apple-system, BlinkMacSystemFont, sans-serif",
        }}
      />
    </Box>
  );
}

DayLabelInput.propTypes = {
  dayKey: PropTypes.string.isRequired,
  defaultLabel: PropTypes.string.isRequired,
};
